import { useTranslation } from "react-i18next";
import { LeftSocialMediaIconUI } from "../components/LeftSocialMediaIconUI";
import { DownloadFileByFileStoreId } from "../components/DownloadFileByFileStoreId";
import { RenderNavItem } from "../components/RenderNavItem";
import { EngineeringLeftMenuList } from "../utils/constants";

export const ManholeDesiltingProgrammeUi = ({ firstList, secondList }) => {
  const { t } = useTranslation();
  return (
    <>
      <section id="hero" className="hero hero2">
        <LeftSocialMediaIconUI />

        <div className="carousel-item active">
          <img src="assets/img/inner-bg2.png" className="img-fluid" alt="alt" />
        </div>
      </section>
      {/* End Slider */}

      <section className="section inner-pad1">
        <div className="container">
          <div className="row">
            <div className="col-lg-3">
              <div className="site-menu  ">
                <nav className="sidebar card py-2">
                  <ul className="nav flex-column" id="nav_accordion">
                    {EngineeringLeftMenuList.map((item, index) => (
                      <RenderNavItem item={item} index={index} t={t} />
                    ))}
                  </ul>
                </nav>
              </div>
            </div>
            <div className="col-lg-9">
              <div className="container">
                <div className="row">
                  <div className="inner-title2">
                    <h3 className="fontSizeClass">
                      Manhole Desilting Programme
                    </h3>
                  </div>
                  <div className="about-head1">
                    <div className="dig-login1 dig-login2">
                      <form>
                        <div className="log-form inner-log-form">
                          <div className="row">
                            <div className="col-lg-6 col-md-6 form-group pt-2">
                              <ol className="list-of-forms">
                                {firstList.map(
                                  ({ fileStoreId, label }, index) => (
                                    <li className="fontSizeClass" key={index}>
                                      <DownloadFileByFileStoreId
                                        fileStoreId={fileStoreId}
                                        label={label}
                                      />
                                    </li>
                                  )
                                )}
                              </ol>
                            </div>
                            <div className="col-lg-6 col-md-6 form-group pt-2">
                              <ol className="list-of-forms" start={9}>
                                {secondList.map(
                                  ({ fileStoreId, label }, index) => (
                                    <li className="fontSizeClass" key={index}>
                                      <DownloadFileByFileStoreId
                                        fileStoreId={fileStoreId}
                                        label={label}
                                      />
                                    </li>
                                  )
                                )}
                              </ol>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

const Engi_Man_Desil_Prog_civil_Bro_30_6_2024 = () => (
  <ManholeDesiltingProgrammeUi
    firstList={[
      {
        fileStoreId: "72650523-eb7a-4630-9ff6-8e0442fe5b29",
        label: "Manhole desilting Br-I",
      },
      {
        fileStoreId: "b910ca52-ef7e-420f-8b04-938eddec9ed1",
        label: "Manhole desilting Br-II",
      },
      {
        fileStoreId: "3ab155dc-3732-4908-939f-761928ddb06c",
        label: "Manhole desilting Br-III",
      },
      {
        fileStoreId: "f08a00c8-3a22-494a-8722-10627c270af0",
        label: "Manhole desilting Br-IV",
      },
      {
        fileStoreId: "6bed4920-b2aa-475e-a575-25833391d87b",
        label: "Manhole desilting Br-V",
      },
      {
        fileStoreId: "82c28a51-c97f-4a8f-9520-6ea883079600",
        label: "Manhole desilting Br-VI",
      },
      {
        fileStoreId: "53473812-dd16-46d5-b2b0-da43b6526866",
        label: "Manhole desilting Br-VII",
      },
      {
        fileStoreId: "34132abb-d7f7-4fee-914d-f9a3ef56666e",
        label: "Manhole desilting Br-VIII",
      },
    ]}
    secondList={[
      {
        fileStoreId: "6fb99b00-1ec7-4c0f-86fe-c055e852782f",
        label: "Manhole desilting Br-IX",
      },
      {
        fileStoreId: "0d85ce31-92a8-4568-8a05-730d9f1c4ea0",
        label: "Manhole desilting Br-X",
      },
      {
        fileStoreId: "1192cea2-d118-480f-9080-e24dfa08c035",
        label: "Manhole desilting Br-XI",
      },
      {
        fileStoreId: "44f959e1-fa13-496b-9922-87801f0e488b",
        label: "Manhole desilting Br-XII",
      },
      {
        fileStoreId: "d60bfa98-90a2-4bf4-a1cf-9bcb23971e27",
        label: "Manhole desilting Br-XIII",
      },
      {
        fileStoreId: "7f375999-8fa8-4025-89e2-529f568ce088",
        label: "Manhole desilting Br-XIV",
      },
      {
        fileStoreId: "c0944689-c1d3-4212-b57d-9fa178986bfa",
        label: "Manhole desilting Br-XV",
      },
      {
        fileStoreId: "909814b5-0797-4aa9-851e-bf1dd0e9ead6",
        label: "Manhole desilting Br-XVI",
      },
    ]}
  />
);

export default Engi_Man_Desil_Prog_civil_Bro_30_6_2024;
